'use strict';

var CompetitorDataSearchCriteriaService = function CompetitorDataSearchCriteriaService(RsqlQuery, legendFilterService, $filter, configurationService, runNumberService) {
  var rmMomentFormat = $filter('rmMomentFormat');
  var hoursInDay = 24;
  function getSearchCriteria(referenceService, originalService, snapshotDate, isShiftShopping) {
    var market = legendFilterService.getSelectedMarket();
    var pos = legendFilterService.getSelectedPos();
    var marketOrigin = market.split('-')[0];
    var marketDestination = market.split('-')[1];
    var eventTimeStamp = buildSnapshotDate(snapshotDate);
    var rsqlQuery = new RsqlQuery();
    var marketQuery;
    var departureDateOutbound, departureDateInbound;
    if (referenceService) {
      departureDateOutbound = originalService.direction === 'OUTBOUND' ? originalService.departureDate : referenceService.departureDate;
      departureDateInbound = originalService.direction === 'OUTBOUND' ? referenceService.departureDate : originalService.departureDate;
    } else {
      departureDateOutbound = originalService.departureDate;
      departureDateInbound = null;
    }
    var commonQueryPart = rsqlQuery.is('marketOrigin').equalTo(marketOrigin).and().is('marketDestination').equalTo(marketDestination).and().is('pos').equalTo(pos);
    if (isShiftShopping) {
      marketQuery = commonQueryPart.and().orGroup(rsqlQuery.is('source').equalTo('COMPETITORFARE').and().is('departureDateOutbound').equalTo(departureDateOutbound).and().is('departureDateInbound').equalTo(departureDateInbound), rsqlQuery.is('source').equalTo('SHOPPINGDATA'));
    } else {
      marketQuery = commonQueryPart.and().is('departureDateOutbound').equalTo(departureDateOutbound).and().is('departureDateInbound').equalTo(departureDateInbound);
    }
    var recommendedFrequency = configurationService.getRecommendedFrequency();
    if (originalService.runNumber && recommendedFrequency > 1) {
      var recommendedDatapull = configurationService.getRecommendedDatapull();
      var recommendedFrequencyOld = configurationService.getRecommendedFrequencyOld();
      var numberOfRunsToPull = recommendedFrequencyOld * recommendedDatapull / hoursInDay;
      var currentRunNumber = originalService.runNumber;
      marketQuery = marketQuery.and().startGroup().is('runNumber').contains(currentRunNumber);
      while (numberOfRunsToPull > 0) {
        currentRunNumber = runNumberService.getPrevRunNumber(currentRunNumber, recommendedFrequencyOld);
        marketQuery = marketQuery.or().is('runNumber').contains(currentRunNumber);
        numberOfRunsToPull--;
      }
      marketQuery = marketQuery.endGroup();
    } else {
      marketQuery = marketQuery.and().is('eventTimeStamp').equalTo(eventTimeStamp);
    }
    return marketQuery.query();
  }
  function buildSnapshotDate(snapshotDate) {
    if (snapshotDate) {
      return rmMomentFormat(snapshotDate.subtract(1, 'days'), 'DATE_ISO');
    }
    return null;
  }
  return {
    getSearchCriteria: getSearchCriteria
  };
};
CompetitorDataSearchCriteriaService.$inject = ['RsqlQueryFactory', 'PricingDepartureDatesLegendFilterService', '$filter', 'ConfigurationService', 'RunNumberService'];
module.exports = CompetitorDataSearchCriteriaService;